import { Button, Select, DatePicker, Checkbox } from 'antd'
import { KurultaiMap } from './map'
import { useGetTerritorialUnitsGetpolygonsListQuery } from '../../redux/api/handBooksApi/territorialUnitsApi'
import { EntTerritorialUnitsFilter } from '../../models/filters/territorialUnitsFilter'
import { useTranslation } from 'react-i18next'
import style from './style.module.css'
import { LeftTable } from './leftTable'
import { useState, useEffect, useCallback } from 'react'
import {
	useGetKurultaiDataMutation,
	useGetKurultaiAreaDataMutation,
	useGetAllDataMutation,
} from './api'
import { PreloaderSvg } from '../preloaderSvg/PreloaderSvg'
import ReportKurultaiModal from '../../pages/admin/kurultaiRegister/reportKurultaiModal'
import { PlusOutlined } from '@ant-design/icons'
import { useGetReportByKurultaiRegisterMutation } from '../../redux/api/kurultai/reportKurultaiApi'
import dayjs from 'dayjs'

export const Kurultai = () => {
    const { t } = useTranslation();
    const [selectedRegionId, setSelectedRegionId] = useState<number | null>(null);
    const [selectedRegionName, setSelectedRegionName] = useState<string>("");
    const [dateRange, setDateRange] = useState<[string | null, string | null]>([null, null]);
    const [showReportModal, setShowReportModal] = useState<boolean>(false);
    const [executionStatusIds, setExecutionStatusIds] = useState<number[]>([]);
    const [isFilterReset, setIsFilterReset] = useState<boolean>(false);
    const [fetchKurultaiData, { data: generalData, isLoading: generalLoading, error: generalError }] = useGetKurultaiDataMutation();
    const [fetchKurultaiAreaData, { data: areaData, isLoading: areaLoading, error: areaError }] = useGetKurultaiAreaDataMutation();
    const [fetchAlldata, { data: allData, isLoading: allLoading, error: allError }] = useGetAllDataMutation();
    const { data: polygonsData, isLoading: polygonsLoading } = useGetTerritorialUnitsGetpolygonsListQuery(
        new EntTerritorialUnitsFilter({ 
            page: 1, 
            size: 1000,
            type: ["REGION"]
        })
    );
    const [getKurultaiReport] = useGetReportByKurultaiRegisterMutation()
    const getReport = async (payload: { languageEnum: string }): Promise<Blob> => {
		return await getKurultaiReport(payload).unwrap()
	}
	const openReportModal = () => {
		setShowReportModal(true)
	}

    const handleRegionClick = useCallback((regionId: number, option: any) => {
        setSelectedRegionId(regionId);
        setSelectedRegionName(option.label);
        setIsFilterReset(false);
    }, []);

    const handleResetFilters = useCallback(() => {
        setExecutionStatusIds([]);
        setDateRange([null, null]);
        setSelectedRegionId(null);
        setSelectedRegionName("");
        setIsFilterReset(true);
    }, []);

	const statusOptions = [
		{ label: 'На исполнении', value: 1 },
		{ label: 'Исполнено', value: 2 },
		{ label: 'Ожидается решение', value: 3 },
	]

    useEffect(() => {
        fetchKurultaiData();
        
        const regionIdsParam = selectedRegionId 
            ? [selectedRegionId] 
            : isFilterReset 
                ? [] 
                : [];
                
        fetchKurultaiAreaData({
            regionIds: regionIdsParam,
            ...(dateRange[0] && dateRange[1] && {
                assemblyDateFrom: dateRange[0],
                assemblyDateTo: dateRange[1]
            }),
            page: 0,
            size: 0
        });
        
        fetchAlldata({
            page: 1,
            size: 1000,
            regionIds: regionIdsParam,
            executionStatusIds,
            ...(dateRange[0] && dateRange[1] && {
              assemblyDateFrom: dateRange[0],
              assemblyDateTo: dateRange[1]
            })
          });
    }, [selectedRegionId, dateRange, executionStatusIds]);

	const handleStatusChange = (checkedValues: number[]) => {
		setExecutionStatusIds(checkedValues)
	}

    const isLoading = polygonsLoading || allLoading;
    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <PreloaderSvg />
            </div>
        );
    }

    return (
        <div className={style.container}>
            <div className={style.content}>
                <div className={style.title}>
                    
                    <div className={style.title_header}>
                        <h1>Курултай</h1>
                        <span style={{ marginLeft: '20px', fontSize: '16px', fontWeight: 500 }}>
                            Всего поручений: {allData?.res?.totalElements || 0}
                        </span>
                        <Button
                            style={{ marginLeft: '5px' }}
                            type='primary'
                            icon={<PlusOutlined />}
                            onClick={openReportModal}
                        >
                            {t('general.generate_report')}
                        </Button>
                        <ReportKurultaiModal
				getReport={getReport}
				show={showReportModal}
				onHide={() => setShowReportModal(false)}
			/>
                    </div>
                    <div className={style.title_inner}>
                        <img src="./homeicon.svg" alt="home" />
                        <p>{t('Home')}</p>
                        <img src="./arrowright.svg" alt="arrow" />
                        <p>Курултай</p>
                    </div>
                </div>
              
            </div>
            <div className={style.tables_and_map}>
                <div className={style.tableContainer}>
                    <LeftTable data={generalData} isLoading={generalLoading} />
                </div>
                <div className={style.mapcontainer}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        position: 'absolute',
                        top: '5px',
                        right: '305px',
                        zIndex: 999,
                        background: 'white',
                        padding: '8px',
                        borderRadius: '4px',
                    }}>
                        <div className={style.execution_status}>
                            <Checkbox.Group 
                                options={statusOptions} 
                                value={executionStatusIds}
                                onChange={handleStatusChange}
                            />
                        </div>
                        <DatePicker.RangePicker
                            value={dateRange[0] ? [dayjs(dateRange[0]), dayjs(dateRange[1])] : null}
                            placeholder={['Начальная дата', 'Конечная дата']}
                            onChange={(dates, dateStrings) => {
                                if (dates) {
                                    setDateRange([dateStrings[0], dateStrings[1]]);
                                } else {
                                    setDateRange([null, null]);
                                }
                            }}
                        />
                        <Button 
                            onClick={handleResetFilters}
                            size="small"
                            type="text"
                            style={{ padding: '4px 8px' }}
                        >
                            Сбросить
                        </Button>
                    </div>
                    <KurultaiMap
                        latitude={43.101719}
                        longitude={81.768897}
                        polygonsData={polygonsData}
                        data={allData}
                        areaData={areaData}
                        onRegionClick={handleRegionClick}
                        selectedRegionName={selectedRegionName}
                        selectedRegionId={selectedRegionId}
                        polygonsLoading={polygonsLoading}
                    />
                </div>
            </div>
        </div>
    );
};
